import React from 'react';
import PropTypes from 'prop-types';

import TeamTypeFilter from 'Common/Components/TeamTypeFilter/TeamTypeFilter.container';
import Refiner from 'Common/Components/Refiner/Refiner.container';
import Updater from '../Components/Updater/Updater.container';
import ExportCsvButton from 'Common/Buttons/ExportCsvButton';
import Page from 'Common/Layout/Page';
import Section from 'Common/Layout/Section';
import Panel from 'Common/Layout/Panel';
import DataTable, { schemaShape } from 'Common/Table/DataTable';
import classNames from './AppointmentList.module.css';
import { fieldShape } from 'Common/Components/Refiner/Refiner.props';

const AppointmentListView = ({
    appointmentSchema,
    refinerFields,
	appointments,
	refinerOpen,
	toggleRefiner,
	refinedAppointments,
	onRefinementChange,
	displayAppointments,
	filterOpen,
	toggleFilter,
	isFiltering,
	setIsFiltering,
	year,
	updateYear,
	updaterOpen,
	toggleUpdater,
	grouping,
	inPreview,
	setInPreview,
	setDisplayAppointments,
	displayTitle,
	viewDataOpen,
	setViewDataOpen,
	startNewFilter,
	toggleViewData,
    handleFilterClear,
    handleFilterSubmit,
    startNewUpdate
}) => {
	return (
		<Page title="Appointment Management">
			<Section>
				<TeamTypeFilter
					open={filterOpen}
					togglePanel={toggleFilter}
					isFiltering={isFiltering}
					setIsFiltering={setIsFiltering}
					grouping={grouping}
                    year={year}
                    numberOfPreviousYears={1}
                    numberOfFutureYears={1}
					updateYear={updateYear}
					startNewFilter={startNewFilter}
                    onClear={handleFilterClear}
                    onSubmit={handleFilterSubmit}
				/>
			</Section>

			<Section>
				<Refiner
                    disabled={isFiltering}
                    fields={refinerFields}
					open={refinerOpen}
					readOnly={inPreview}
					data={appointments}
					onRefinementChange={onRefinementChange}
					onPanelToggleClick={toggleRefiner}
				/>
			</Section>

			<Section>
				<Updater
                    disabled={isFiltering}
					year={year}
					updaterOpen={updaterOpen}
					setUpdaterOpen={toggleUpdater}
					grouping={grouping}
					inPreview={inPreview}
					setInPreview={setInPreview}
					isFiltering={isFiltering}
					refinedAppointments={refinedAppointments || appointments}
					setDisplayAppointments={setDisplayAppointments}
					viewDataOpen={viewDataOpen}
					setViewDataOpen={setViewDataOpen}
                    startNewUpdate={startNewUpdate}
				/>
			</Section>

			<Section>
				<Panel variant='collapsable' open={viewDataOpen} disabled={isFiltering} title={displayTitle} onToggle={toggleViewData}>
					<div className={classNames['data-table']}>
						<DataTable
							keyField="appointmentId"
							dataSource={displayAppointments}
							pagination
							schema={appointmentSchema} />
					</div>
					<div className={classNames['export-button']}>
						<ExportCsvButton
							dataSource={displayAppointments}
							fileName='appointments.csv'
							includeHeaders={true}
							schema={appointmentSchema} />
					</div>
				</Panel>
			</Section>
		</Page>
	);
};

AppointmentListView.propTypes = {
    appointmentSchema: PropTypes.arrayOf(PropTypes.shape(schemaShape)).isRequired,
    refinerFields: PropTypes.arrayOf(PropTypes.shape(fieldShape)).isRequired,
	appointments: PropTypes.array.isRequired,
	refinerOpen: PropTypes.bool.isRequired,
	toggleRefiner: PropTypes.func.isRequired,
	refinedAppointments: PropTypes.array,
	onRefinementChange: PropTypes.func.isRequired,
	displayAppointments: PropTypes.array,
	filterOpen: PropTypes.bool.isRequired,
	toggleFilter: PropTypes.func.isRequired,
	isFiltering: PropTypes.bool.isRequired,
	setIsFiltering: PropTypes.func.isRequired,
	year: PropTypes.string,
	updateYear: PropTypes.func.isRequired,
	updaterOpen: PropTypes.bool.isRequired,
	toggleUpdater: PropTypes.func.isRequired,
	grouping: PropTypes.string.isRequired,
	inPreview: PropTypes.bool.isRequired,
	setInPreview: PropTypes.func.isRequired,
	setDisplayAppointments: PropTypes.func.isRequired,
	displayTitle: PropTypes.string,
	viewDataOpen: PropTypes.bool.isRequired,
	setViewDataOpen: PropTypes.func.isRequired,
	startNewFilter: PropTypes.func.isRequired,
	toggleViewData: PropTypes.func.isRequired,
    startNewUpdate: PropTypes.func.isRequired,
};

export default AppointmentListView;
